var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.37 14.465c0-.642-.062-1.305-.166-1.927h-8.972v3.668h5.139a4.323 4.323 0 0 1-1.907 2.88l3.067 2.384c1.803-1.679 2.84-4.124 2.84-7.005z",
    fill: "#4280EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.232 23.749c2.57 0 4.724-.85 6.3-2.3l-3.068-2.363c-.85.58-1.948.912-3.232.912-2.487 0-4.58-1.678-5.347-3.917l-3.15 2.425a9.502 9.502 0 0 0 8.497 5.243z",
    fill: "#34A353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.885 16.06a5.778 5.778 0 0 1 0-3.646l-3.15-2.446a9.525 9.525 0 0 0 0 8.538l3.15-2.445z",
    fill: "#F6B704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.232 8.497a5.19 5.19 0 0 1 3.647 1.43l2.714-2.736a9.154 9.154 0 0 0-6.361-2.466 9.502 9.502 0 0 0-8.497 5.243l3.15 2.446c.767-2.26 2.86-3.917 5.347-3.917z",
    fill: "#E54335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.172c86f0a7f66dfce4bcd802e57bf4d1.svg";
export { ForwardRef as ReactComponent };